{
  "ui": {
    "feedback": "Synpunkter",
    "credits": "Medverkande",
    "currentMaintainer": "Nuvarande förvaltare",
    "maintainerPeriod": "Från 2026 och framåt",
    "originalTeam": "Det ursprungliga teamet",
    "creditsCampaigns": "Djungel och jul",
    "moreSettings": "Fler inställningar",
    "chooseLanguage": "Välj ditt språk",
    "notebookTools": "Verktyg för anteckningsboken",
    "visualGuide": "Bildguide",
    "templeSoon": "Kommer snart",
    "playAdventure": "Spela",
    "story": "Berättelsen",
    "loadingAdventure": "Vi packar för äventyret…",
    "storyOpening": "En skolutflykt till djungeln. Marco och Sophia utforskar med sina vänner. En färgglad fågel fångar Marcos uppmärksamhet och han följer den mellan träden. Plötsligt är han ensam. Hjälp upptäckarna att hitta vägen!",
    "storyEnding": "Marco och Sophia når det försvunna templet tillsammans. Ett mystiskt ansikte vaktar ingången. Ett nytt äventyr väntar!",
    "blockCategories": "Anteckningsbokens flikar",
    "actions": "Handlingar",
    "loops": "Slingor",
    "conditions": "Villkor",
    "title": "Run Marco! — Ett äventyr i din anteckningsbok",
    "home": "Run Marcos startsida",
    "map": "Äventyrskarta",
    "worlds": "Välj ett äventyr",
    "notebook": "Min anteckningsbok",
    "notebookToggle": "Öppna eller stäng anteckningsboken",
    "notebookOpen": "Öppna anteckningsboken",
    "notebookClose": "Titta på stigen",
    "page": "Sida {number}",
    "level": "Bana {number}",
    "run": "Nu kör vi!",
    "stop": "Stopp",
    "step": "Ett steg",
    "stepTitle": "Kör en instruktion",
    "reset": "Tillbaka till start",
    "add": "Lägg till",
    "addLabel": "Välj ett block att lägga till",
    "addHint": "Sätt ihop blocken och tryck på Spela.",
    "undo": "Ångra",
    "clear": "Ny sida",
    "hint": "En liten ledtråd",
    "help": "Så spelar du",
    "settings": "Inställningar",
    "language": "Spelets språk",
    "blockLanguage": "Blockens språk",
    "blockLanguageNote": "Du kan välja ett annat språk för blocken.",
    "musicOn": "Slå på ljudet",
    "musicOff": "Stäng av ljudet",
    "sound": "Musik och ljudeffekter",
    "speed": "Äventyrets hastighet",
    "chooseExplorer": "Välj din upptäckare",
    "explorer": "Upptäckare",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Stäng",
    "done": "Dags att utforska!",
    "loading": "Vi hittar stigen…",
    "loadError": "Äventyret kunde inte laddas. Ladda om sidan för att försöka igen.",
    "imageError": "Vissa bilder kunde inte laddas. Ladda om sidan.",
    "gemGoal": "Hitta ädelstenen",
    "goal": "Hitta den gyllene stjärnan",
    "cover": "Tänd varje ruta precis en gång",
    "lit": "{count} / {total} rutor tända",
    "explored": "{count} / {total} banor utforskade",
    "facing": "Tittar åt {direction} {arrow}",
    "boardLabel": "{name} på {level}, tittar åt {direction}. {steps}. {objective}.",
    "up": "uppåt",
    "down": "nedåt",
    "left": "vänster",
    "right": "höger",
    "steps_one": "{count} steg",
    "steps_other": "{count} steg",
    "blocks_one": "{count} block",
    "blocks_other": "{count} block",
    "stars_one": "{count} stjärna",
    "stars_other": "{count} stjärnor",
    "place": "Lägg till block",
    "atEnd": "I slutet",
    "insideRepeat": "Inuti upprepa {number}",
    "insideIf": "Inuti om {number}",
    "insideElse": "Inuti annars {number}",
    "readyFirst": "Ett litet steg. Lägg till ett framåtblock, så kör vi!",
    "ready": "Vart ska vi? Gör en plan i anteckningsboken.",
    "back": "Tillbaka vid start. Dina block är redo för ett nytt försök.",
    "empty": "Lägg först till ett block i anteckningsboken.",
    "win": "Du hittade vägen!",
    "winCover": "Du lyste upp stigen!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Vilket äventyr!",
    "simpler": "Kan du använda färre block?",
    "complete": "Banan är klar! Dina bästa stjärnor har sparats.",
    "next": "Nästa bana",
    "allWorlds": "Fler äventyr",
    "replay": "Spela igen",
    "shortGoal": "Nästan! Lägg till fler block för att nå stjärnan.",
    "shortGem": "Nästan! Lägg till fler block för att nå ädelstenen.",
    "shortCover": "Vissa rutor är fortfarande mörka. Hur når vi dem?",
    "checking": "Vi tittar på stigen…",
    "paused": "Stoppat. Spela börjar om från början.",
    "going": "Nu går vi!",
    "stepped": "Ett steg närmare. Tryck på Ett steg eller Spela för att fortsätta.",
    "clueCover": "Börja vid en kant och följ hela formen. Ett hopp passerar en ruta utan att tända den.",
    "clueCondition": "Titta på stigen framför dig. Ett villkor hjälper upptäckaren att välja vad som ska göras.",
    "clueRepeat": "Vilka steg återkommer? Lägg mönstret i ett upprepningsblock.",
    "clueForward": "Framåt följer upptäckarens blick. Räkna rutorna till stjärnan.",
    "clueGem": "Framåt följer upptäckarens blick. Räkna rutorna till ädelstenen.",
    "clueTurn": "Att svänga ändrar riktningen utan att flytta dig. Följ stigen med fingret.",
    "mapNote": "Välj en bana. Dina bästa stjärnor sparas.",
    "mapLevel": "Bana {number}: {name}. {stars}.",
    "locked": "Klara föregående bana för att låsa upp den här.",
    "soundBlocked": "Tryck på ljudknappen för att höra äventyret.",
    "clearTitle": "Börja på en ny sida?",
    "clearNote": "Blocken för den här banan raderas. Ångra kan ta tillbaka dem.",
    "keep": "Behåll mina block",
    "clearConfirm": "Radera block",
    "fresh": "En ny sida. Vart leder din nästa plan oss?",
    "localProgress": "Dina framsteg sparas på den här enheten.",
    "helpBuild": "Gör en plan",
    "helpBuildText": "Dra block till anteckningsboken och koppla ihop dem, eller tryck på ett block för att lägga till det. Välj ”Inuti upprepa” för steg i en slinga.",
    "helpTurn": "Följ din upptäckare",
    "helpTurnText": "Framåt följer blicken. Vänster och höger svänger på stället. Ett hopp går två rutor fram.",
    "helpTry": "Försök, titta, försök igen",
    "helpTryText": "Tryck på Spela för planen eller Ett steg för en instruktion. Den böjda pilen går tillbaka till start och behåller blocken.",
    "helpWorlds": "Varje äventyr har ett mål",
    "helpWorldsText": "Hitta ädelstenen i Djungeln. Tänd varje ledig ruta en gång i juläventyret. Slutför reparationerna och de synliga målen i Templet och Egeiska havet och nå utgången.",
    "noTrail": "Där finns ingen stig! Försök att svänga först.",
    "broken": "Den bron är trasig. Kan du hoppa över den?",
    "blocked": "Något är i vägen. Prova ett hopp eller en annan väg.",
    "alreadyLit": "Den rutan är redan tänd. Besök varje ruta bara en gång.",
    "loopError": "Planen upprepas utan slut. Försök ändra slingan.",
    "repeatError": "Välj ett antal upprepningar från 1 till 99.",
    "unsupported": "Ta bort blocket som inte stöds och försök igen.",
    "connect": "Koppla ihop blocken till en kedja och tryck på Spela.",
    "path": "stig",
    "backpack": "Ryggsäck",
    "templeGems": "Templets ädelstenar",
    "gemsCollected": "Ädelstenar: {count} / {total}",
    "gemsReady": "Alla ädelstenar är samlade!",
    "aegeanTitle": "Egeiska havets hemligheter",
    "harbour": "Hamn",
    "aegeanDescription": "Utforska hamnen: reparera stationer, återanvänd rutiner och skicka ett tal med varje uppdrag.",
    "templeBetaNote": "Beta · Vi bearbetar pusslen och lektionerna",
    "aegeanBetaNote": "Beta · Hamnens första 3 banor",
    "seasonal": "Säsongsäventyr",
    "choosePreview": "Välj en provbana",
    "repairs": "Reparationer",
    "reachExit": "Nå utgången",
    "taskRequirements": "Uppdragets mål",
    "lessonGuided": "Guidad övning · färdigställ det givna programmet",
    "lessonRepair": "Felsökning · rätta det givna programmet",
    "lessonChallenge": "Utmaning · skapa ditt eget program",
    "acc_define_parameter": "Rutin",
    "acc_call_argument": "Anropa rutin",
    "acc_repeat_parameter": "Upprepa med indata",
    "parameter": "parameter",
    "argument": "skicka",
    "callInput": "Indata för detta anrop",
    "inputWaiting": "Kör programmet eller en instruktion i taget för att se nästa indata.",
    "argumentMismatch": "En rutin med en parameter behöver ett anrop med ett tal. Utan parameter används ett vanligt anrop.",
    "unsetParameter": "Använd bara parametern i rutinen som tar emot den. Parametrar är skilda från det delade minnet.",
    "memoryObjective": "Kontrollera reparationsloggen och kraven vid utgången. Alla program som uppfyller dem godkänns.",
    "gate": "Vägen är blockerad. Kontrollera de ofärdiga reparationerna.",
    "noPickup": "Ställ dig på verktyget innan du plockar upp det.",
    "creditLead": "Teamledning och programutveckling",
    "creditArt": "Illustration och miljöer",
    "creditAnimation": "Animation",
    "creditUX": "Gränssnitts- och användarupplevelsedesign",
    "creditDesign": "Speldesign",
    "creditStory": "Berättelse",
    "creditAudio": "Musik och ljudteknik",
    "lightLamp": "Tänd lampan",
    "oilLamp": "Oljelampa",
    "dustyStation": "dammig station",
    "betaLabel": "Beta",
    "noLamp": "Stå på en släckt lampa innan du tänder den.",
    "collected": "Verktyg upplockat · klart att använda",
    "dustyPrompt": "Stå på en dammig station innan du använder penseln.",
    "lampMissing": "Plocka upp oljelampan först. Titta i ryggsäcken.",
    "recursiveRoutine": "Den här rutinen anropar sig själv. Använd en annan rutin; rekursiva anrop är inte tillgängliga ännu."
  },
  "content": {
    "jungle.title": "Djungelutflykt",
    "jungle.description": "Följ stigen till det försvunna templet.",
    "jungle-1": "Första stegen",
    "jungle-2": "Lite längre",
    "jungle-3": "Runt hörnet",
    "jungle-4": "Byt riktning",
    "jungle-5": "Följ stigen",
    "jungle-6": "En ny väg",
    "jungle-7": "Nya stigar",
    "jungle-8": "Djungelkorsning",
    "jungle-9": "Hitta vägen",
    "jungle-10": "Tänk framåt",
    "jungle-11": "Den långa stigen",
    "jungle-12": "En slingrande väg",
    "jungle-13": "Ett modigt hopp",
    "jungle-14": "Mönster visar sig",
    "jungle-15": "Upprepa rytmen",
    "jungle-16": "Välj en stig",
    "jungle-17": "Titta innan du hoppar",
    "jungle-18": "Läs stigen",
    "jungle-19": "En smart omväg",
    "jungle-20": "Under trädkronorna",
    "jungle-21": "Brobyggare",
    "jungle-22": "Bortom floden",
    "jungle-23": "Utforska ruinerna",
    "jungle-24": "Sten och trä",
    "jungle-25": "Ett större hopp",
    "jungle-26": "Följ ledtrådarna",
    "jungle-27": "Högre upp",
    "jungle-28": "Fortsätt utforska",
    "jungle-29": "Slingrande stigar",
    "jungle-30": "Den hemliga trädgården",
    "jungle-31": "Dolda mönster",
    "jungle-32": "Uråldriga stigar",
    "jungle-33": "De sista svängarna",
    "jungle-34": "Mot templet",
    "jungle-35": "Nästan framme",
    "jungle-36": "Det försvunna templet",
    "winter.title": "Vinterstig",
    "winter.description": "Låt varje fotspår lysa.",
    "winter-1": "Steg i snön",
    "winter-2": "En annan riktning",
    "winter-3": "Frusna hörn",
    "winter-4": "Den långa omvägen",
    "winter-5": "Snöflinga",
    "winter-6": "Vinterslingor",
    "winter-7": "Isupptäckare",
    "winter-8": "Svängar och vändningar",
    "winter-9": "Iskall logik",
    "winter-10": "Mönsterletare",
    "winter-11": "Stigens mästare",
    "winter-12": "Vinterunder",
    "temple.title": "Det försvunna templet",
    "temple.description": "Fyrtio sammanhängande rum. Återställ ett himmelsinstrument med verktyg, minne och egna rutiner."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Papperskorgen är tom",
    "OPEN_TRASH": "Öppna papperskorgen",
    "BLOCK_LABEL_BEGIN_STACK": "Början av stapeln",
    "WORKSPACE_LABEL_1_STACK": "1 stapel med block",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 staplar med block",
    "ARIA_TYPE_FIELD_NUMBER": "tal",
    "ARIA_TYPE_FIELD_DROPDOWN": "rullgardinslista",
    "ARIA_TYPE_FIELD_IMAGE": "bild",
    "WORKSPACE_LABEL_PLAIN": "Min anteckningsbok",
    "FIELD_LABEL_EDIT_PREFIX": "Redigera %1",
    "BLOCK_LABEL_HAS_INPUT": "har inmatning",
    "BLOCK_LABEL_HAS_INPUTS": "har flera inmatningar",
    "BLOCK_LABEL_HAS_BRANCHES": "har %1 grenar",
    "FIELD_LABEL_OPTION_INDEX": "Alternativ %1",
    "INPUT_LABEL_EMPTY": "Tom",
    "BLOCK_LABEL_DISABLED": "inaktiverad",
    "BLOCK_LABEL_COLLAPSED": "hopfälld",
    "BLOCK_LABEL_BEGIN_PREFIX": "Början: %1",
    "INPUT_LABEL_END_STATEMENT": "Slut: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "text",
    "ARIA_TYPE_FIELD_INPUT": "indata",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "namn på indata",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "rutinnamn"
  }
}
